import React, {useEffect, useState} from "react";
import WidgetDemoFrame from "./widget-demo-frame";
import {sceneDuration} from "./demo-scenarios";

const FADE_MS = 700;

const HeroScene = ({scenes, rotate = false, height = 620, priority = true, className = ""}) => {
    const [index, setIndex] = useState(0);
    const [fading, setFading] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined" || !rotate || scenes.length < 2) return undefined;
        scenes.forEach((s, i) => { if (i !== index) { const img = new Image(); img.src = s.src; } });
        const timer = setTimeout(() => {
            setFading(true);
            setTimeout(() => {
                setIndex((i) => (i + 1) % scenes.length);
                setFading(false);
            }, FADE_MS);
        }, sceneDuration(scenes[index].scenariusz));
        return () => clearTimeout(timer);
    }, [index, rotate, scenes]);

    const scene = scenes[Math.min(index, scenes.length - 1)];

    return (
        <div
            className={`relative w-full rounded-[10px] overflow-hidden transition-opacity duration-[700ms] ease-in-out motion-reduce:transition-none ${
                fading ? "opacity-0" : "opacity-100"
            } ${className}`}
            style={{height, background: scene.tint || "transparent"}}
        >
            <div className="hidden sm:block absolute top-[8%] bottom-[8%] left-0 w-[40%] rounded-[10px] overflow-hidden">
                {scenes.map((s, i) => (
                    <img
                        key={s.src}
                        src={s.src}
                        alt={s.alt}
                        width={462}
                        height={960}
                        loading={i === 0 && priority ? "eager" : "lazy"}
                        className={`absolute inset-0 w-full h-full object-cover object-top ${
                            i === index ? "opacity-100" : "opacity-0"
                        }`}
                    />
                ))}
            </div>

            <div className="absolute inset-y-0 right-0 left-0 sm:left-[39%]">
                <WidgetDemoFrame height={height} priority={priority} scenario={scene.scenariusz} label={false}/>
            </div>
        </div>
    );
};

export default HeroScene;
